import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip as WmsTooltip } from 'react-tooltip';
import TaskInvoicesModal from './TaskInvoicesModal';
import { NO_CHARGES_POSTED } from '../../../utils/taskInvoice';

// Update Task (Admin) "Invoices" button that opens the task's invoice list.
const TaskInvoicesButton = ({ taskId, taskTitle = '', invoices, loading = false }) => {
    const [showInvoices, setShowInvoices] = useState(false);
    const hasDebit = invoices.length > 0;

    return (
        <>
            <span id="taskInvoicesBtn" className="d-inline-block">
                <button
                    type="button"
                    className="btn cus-seconday-bg-btn top-btn"
                    onClick={() => setShowInvoices(true)}
                    disabled={!hasDebit}
                    style={hasDebit ? undefined : { pointerEvents: 'none' }}
                >
                    Invoices
                </button>
            </span>
            {!hasDebit && (
                <WmsTooltip anchorId="taskInvoicesBtn" content={NO_CHARGES_POSTED} place="bottom" className="tooltipWidth" />
            )}
            {showInvoices && (
                <TaskInvoicesModal
                    show={showInvoices}
                    handleCancel={() => setShowInvoices(false)}
                    taskId={taskId}
                    taskTitle={taskTitle}
                    invoices={invoices}
                    loading={loading}
                />
            )}
        </>
    );
};

TaskInvoicesButton.propTypes = {
    taskId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    taskTitle: PropTypes.string,
    invoices: PropTypes.arrayOf(PropTypes.object).isRequired,
    loading: PropTypes.bool,
};

export default TaskInvoicesButton;
